<template>
    <LayoutGradient :title="pageTitle" icon="fa-file-signature">
        <template v-slot:headerRight>
        <b-btn variant="outline-info" @click="$router.back()">
            <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
        </b-btn>
        </template>
        <b-card class="m-3 mt-n10">
            <SimpleForm :fields="fields" :model="model" @submit="onSubmit" class="tipo-form">
                <template v-slot:field(vns_integration_origin_id)>
                    <b-form-group :label="$t('result_range.form.integracao_origem')">
                        <b-overlay :show="isLoading">
                            <v-select
                                id="input-integracao_origem"
                                class="w-100"
                                :value="resultrange.vns_integration_origin_id"                  
                                :options="integrations"
                                :reduce="option => option.id"
                                label="name"
                                v-model="model.vns_integration_origin_id"
                            />
                        </b-overlay>
                    </b-form-group>
                </template>

                <template v-slot:field(vns_integration_destination_id)>
                    <b-form-group :label="$t('result_range.form.integracao_destino')">
                        <b-overlay :show="isLoading">
                            <v-select
                                id="input-integracao_destino"
                                class="w-100"
                                :value="resultrange.vns_integration_destination_id"
                                :options="integrations"
                                :reduce="option => option.id"
                                label="name"
                                v-model="model.vns_integration_destination_id"
                            />
                        </b-overlay>
                    </b-form-group>
                </template>
                <template v-slot:field(tuevs_exam_id)>
                    <b-form-group :label="$t('result_range.form.exame')">
                        <b-overlay :show="isLoading">
                            <SelectTuevsExam class="mb-3" v-model="model.tuevs_exam" :model="model.tuevs_exam" />
                        </b-overlay>
                    </b-form-group>
                </template>
                <template v-slot:field(condicao_id)>
                    <b-form-group :label="$t('result_range.form.condicoes')">
                        <b-overlay :show="isLoading">
                            <ConditionResultRange
                                v-for="(condition, index) in form.conditions"
                                :form="condition"
                                :key="index"
                                :showDescription="condition.showDescription"
                                @change="populateConditions"
                            />
                            <div>
                                <button class="btn btn-sm btn-outline-success"
                                        @click="conditions = [
                                                ...conditions,
                                                {
                                                showDescription: false,
                                                index: conditions.length
                                                }
                                            ]"
                                        type="button"
                                >
                                    <i class="fa fa-plus"></i>
                                    {{ $t('condition_result_range.form.buttons.adicionar_condicao') }}
                                </button>
                                &nbsp;
                                <button v-if="conditions.length > 0"
                                        class="btn btn-sm btn-outline-danger"
                                        @click="conditions.length > 0 ? conditions.pop() : ''"
                                        type="button"
                                >
                                    <i class="fa fa-minus-circle"></i>
                                    {{ $t('condition_result_range.form.buttons.remover_condicao') }}
                                </button>
                            </div>
                        </b-overlay>
                    </b-form-group>
                </template>
                <template #submitButton>
                    <b-button variant="success" type="submit" >
                        <i class="fas fa-save"/> {{ $t('result_range.form.salvar') }}
                    </b-button>
                </template>
            </SimpleForm>
        </b-card>
    </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import TypeRepository from '@/repositories/dexpara/ResultRangeRepository';
import {mapActions, mapGetters} from "vuex";
import SimpleForm from "@/components/FormGenerator/SimpleForm";
import SelectTuevsExam from "@/components/tuevs/Select/SelectTuevsExam";
import ConditionResultRange from '@/pages/triggers/components/ConditionResultRange'

export default {
    name: "Form",
    components: {LayoutGradient, SimpleForm, SelectTuevsExam, ConditionResultRange},
    data() {
        return {
            resultrange_id: null,
            fields: [
                {
                    label: this.$t('vns.form.fields.integracao_origem.label'),
                    name: 'vns_integration_origin_id',
                    description: this.$t('vns.form.fields.integracao_origem.description')
                },
                {
                    label: this.$t('vns.form.fields.integracao_destino.label'),
                    name: 'vns_integration_destination_id',
                    description: this.$t('vns.form.fields.integracao_destino.description')
                },
                {
                    label: this.$t('result_range.form.exame'),
                    name: 'tuevs_exam_id',
                    description: "Exame pertencente a configuração da faixa de resultado"
                },
                {
                    label: this.$t('result_range.form.condicoes'),
                    name: 'condicao_id',
                    description: "Condição de resultado"
                },
                {
                    label: "Status",
                    type: 'checkbox',
                    name: 'status',
                    description: this.$t('result_range.form.status_descricao')
                },
            ],
            model: {
                id: null,
                vns_integration_origin_id: '',
                vns_integration_destination_id: '',
                tuevs_exam_id: '',
                status: false
            },
            conditions: []
        }
    },
    computed: {
        ...mapGetters({
            resultrange: 'dexpara/resultrange/current',
            isLoading: 'dexpara/resultrange/isLoading',
            integrations: 'integration/all',
            integrationsLoading: 'integration/isLoading'
        }),
        pageTitle() {
            if (this.resultrange_id) return this.$t('result_range.form.titulo_editar')
            return this.$t('result_range.form.titulo_criar')
        },
        form() {
            return {
                conditions: this.conditions                
            }
        },
    },
    methods: {
        ...mapActions([
            'dexpara/resultrange/listOne',
            'integration/search',
        ]),
        async onSubmit(evt) {
            if (this.$route.params.id) {
                this.update()
            } else {
                this.create()
            }
        },
        convertConditionsToString() {
            let conditionsArray = []

            this.conditions.forEach((element) => {
                let conditionString = '';
                conditionString += element.firstField + ' ' + element.regra

                if (element.regra === 'IS NULL') {
                conditionString += ' OR ' + element.firstField + ' = ""'
                return
                }
                if (element.regra === 'IS NOT NULL') {
                conditionString += ' OR ' + element.firstField + ' != ""'
                return
                }
                if (element.regra === 'BETWEEN') {
                conditionString += ' ' + element.secondField + ' AND ' + element.thirdField
                return
                }
                if (element.regra === 'NOT BETWEEN') {
                conditionString += ' ' + element.secondField + ' AND ' + element.thirdField
                return
                }

                conditionString += ' ' + element.secondField

                conditionsArray.push({
                    'rule': conditionString,
                    'result': element.fourthField
                });
            })

            return conditionsArray
        },
        convertStringToConditions() {
            let arrayConditions = this.model.conditions
            arrayConditions.forEach((element, index) => {                
                switch (true) {
                case element.rule.includes('IS NULL'):
                    const isNull = element.rule.split(' IS NULL')
                    arrayConditions[index] = {
                    index,
                    firstField: isNull[0],
                    regra: 'IS NULL',
                    secondField: null,
                    thirdField: null,
                    fourthField: null
                    }
                    break;
                case element.rule.includes('IS NOT NULL'):
                    const isNotNull = element.rule.split(' IS NOT NULL')
                    arrayConditions[index] = {
                    index,
                    firstField: isNotNull[0],
                    regra: 'IS NOT NULL',
                    secondField: null,
                    thirdField: null,
                    fourthField: null
                    }
                    break;
                case element.rule.includes('NOT BETWEEN'):
                    const notBtween = element.rule.split(' NOT BETWEEN ')
                    arrayConditions[index] = {
                    index,
                    firstField: notBtween[0],
                    regra: 'NOT BETWEEN',
                    secondField: notBtween[1].split(' AND ')[0],
                    thirdField: notBtween[1].split(' AND ')[1],
                    fourthField: element.result
                    }
                    break;
                case element.rule.includes('BETWEEN'):
                    const btween = element.rule.split(' BETWEEN ')
                    arrayConditions[index] = {
                    index,
                    firstField: btween[0],
                    regra: 'BETWEEN',
                    secondField: btween[1].split(' AND ')[0],
                    thirdField: btween[1].split(' AND ')[1],
                    fourthField: element.result
                    }
                    break;
                case element.rule.includes('>='):
                    arrayConditions[index] = {
                    index,
                    firstField: element.rule.split(' >= ')[0],
                    regra: '>=',
                    secondField: element.rule.split(' >= ')[1],
                    thirdField: null,
                    fourthField: element.result
                    }
                    break;
                case element.rule.includes('>'):
                    arrayConditions[index] = {
                    index,
                    firstField: element.rule.split(' > ')[0],
                    regra: '>',
                    secondField: element.rule.split(' > ')[1],
                    thirdField: null,
                    fourthField: element.result
                    }
                    break;
                case element.rule.includes('<='):
                    arrayConditions[index] = {
                    index,
                    firstField: element.rule.split(' <= ')[0],
                    regra: '<=',
                    secondField: element.rule.split(' <= ')[1],
                    thirdField: null,
                    fourthField: element.result
                    }
                    break;
                case element.rule.includes('<'):
                    arrayConditions[index] = {
                    index,
                    firstField: element.rule.split(' < ')[0],
                    regra: '<',
                    secondField: element.rule.split(' < ')[1],
                    thirdField: null,
                    fourthField: element.result
                    }
                    break;
                case element.rule.includes('=='):
                    arrayConditions[index] = {
                    index,
                    firstField: element.rule.split(' == ')[0],
                    regra: '==',
                    secondField: element.rule.split(' == ')[1],
                    thirdField: null,
                    fourthField: element.result
                    }
                    break;
                case element.rule.includes('!='):
                    arrayConditions[index] = {
                    index,
                    firstField: element.rule.split(' != ')[0],
                    regra: '!=',
                    secondField: element.rule.split(' != ')[1],
                    thirdField: null,
                    fourthField: element.result
                    }
                    break;
                }
            })
            this.conditions = arrayConditions
        },
        populateConditions(condition) {
            this.form.conditions.forEach((element, idx) => {
                if (element.index === condition.index) {
                this.form.conditions[idx] = condition
                }
            });
        },
        create() {
            if (this.model.vns_integration_origin_id == '') {
                this.$snotify.error(this.$t('result_range.form.integracao_origem_obrigatoria'))
                return;
            }

            if (this.model.vns_integration_origin_id == '') {
                this.$snotify.error(this.$t('result_range.form.integracao_destino_obrigatoria'))
                return;
            }

            if (this.model.tuevs_exam === undefined) {
                this.$snotify.error(this.$t('result_range.form.exame_obrigatorio'))
                return;
            }

            this.model.tuevs_exam_id = this.model.tuevs_exam.value;            
            this.model.conditions = this.convertConditionsToString()

            TypeRepository.post(this.model).then(() => {
                this.$snotify.success(this.$t('result_range.form.criada_sucesso'))
                this.$router.push({name: 'resultrange'})
            }).catch(error => {
                if (error.response.status === 422) {
                    TypeRepository.toastValidationErrors(error, this.$snotify)
                }
            })
        },
        update() {
            if (this.model.vns_integration_origin_id == '') {
                this.$snotify.error(this.$t('result_range.form.integracao_origem_obrigatoria'))
                return;
            }

            if (this.model.vns_integration_origin_id == '') {
                this.$snotify.error(this.$t('result_range.form.integracao_destino_obrigatoria'))
                return;
            }

            if (this.model.tuevs_exam === undefined) {
                this.$snotify.error(this.$t('result_range.form.exame_obrigatorio'))
                return;
            }

            this.model.tuevs_exam_id = this.model.tuevs_exam.value;            
            this.model.conditions = this.convertConditionsToString()

            TypeRepository.put(this.resultrange_id, this.model).then(() => {
                this.$snotify.success(this.$t('result_range.form.editada_sucesso'))
                this.$router.push({name: 'resultrange'})
            }).catch(error => {
                //this.$snotify.error(this.$t('tipo.form.update.error'))
                if (error.response.status === 422) {
                    TypeRepository.toastValidationErrors(error, this.$snotify)
                }
            })
        }
    },
    async mounted() {
        this.$store.commit('dexpara/resultrange/setCurrent', {status: false})
        this['integration/search']()
        if (this.$route.params.id) {
            this.resultrange_id = this.$route.params.id            
            await this['dexpara/resultrange/listOne'](this.$route.params.id)
            this.model = {
                ...this.model,
                ...this.resultrange.data.mappingResultRange,
                conditions: this.resultrange.data.mappingResultRangeConditions,
                status: !!this.resultrange.data.mappingResultRange.status || false,
                tuevs_exam: { "label": this.resultrange.data.mappingResultRange.tuevs_exam_name, "value": this.resultrange.data.mappingResultRange.tuevs_exam_id }
            }
            this.convertStringToConditions()
        }
    },
}
</script>
